import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { KeyRound, ArrowLeft } from "lucide-react";

// There is no mail server behind this installation, so there is no reset link to send.
// The way back in is a person, and this page's whole job is to say which person and stop
// somebody guessing at the sign-in box until the throttle locks their address out.
//
// If email is ever wired up, it belongs here: this route is already the one thing the
// login screen points at, so a form can replace the explanation without moving anything.
export default function ForgotPassword() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <Card className="w-full max-w-md p-8 border border-border" data-testid="forgot-password-card">
        <div className="w-10 h-10 rounded-md bg-primary/10 text-primary flex items-center justify-center">
          <KeyRound className="w-5 h-5" />
        </div>
        <h2 className="font-heading font-bold text-2xl mt-4">Forgotten your password?</h2>
        <p className="text-sm text-muted-foreground mt-2">
          Abhyas does not send password emails. Your administrator sets a new one for you.
        </p>

        <ol className="mt-5 space-y-3 text-sm list-decimal pl-5 marker:text-muted-foreground">
          <li>Ask whoever administers Abhyas for your organisation to reset it.</li>
          <li>
            They open <b>Users &amp; Roles</b>, find your name and choose <b>Reset password</b>.
            A one-time password appears on their screen.
          </li>
          <li>Sign in with it. You are asked to set your own password straight away.</li>
        </ol>

        <p className="text-xs text-muted-foreground mt-5">
          The one-time password is shown to them once and is never emailed or stored anywhere you
          could read it later, so take it down when they give it to you.
        </p>

        <Button asChild variant="outline" className="w-full mt-6" data-testid="forgot-back-to-login">
          <Link to="/login"><ArrowLeft className="w-4 h-4 mr-1.5" /> Back to sign in</Link>
        </Button>
      </Card>
    </div>
  );
}
